import {
  isPartnerBrand,
  loginPageThemeStyle,
  resolvePartnerBrandPrimary,
} from "./loginPartnerTheme";

type SiteOptions = Parameters<typeof loginPageThemeStyle>[0];

const PARTNER_THEME_VARS = [
  "--login-accent",
  "--login-accent-rgb",
  "--login-primary",
  "--login-primary-rgb",
  "--valut-gold-accent",
  "--valut-gold-gradient",
  "--valut-gold-gradient-tint",
  "--valut-input-border",
  "--valut-input-border-hover",
  "--valut-input-border-focus",
  "--valut-input-focus-ring",
  "--partner-primary",
  "--partner-accent",
  "--partner-accent-rgb",
  "--partner-primary-rgb",
  "--brand-accent",
  "--brand-accent-light",
  "--brand-accent-muted",
  "--brand-accent-soft",
  "--brand-accent-soft-bg",
  "--brand-badge-bg",
  "--brand-badge-border",
  "--brand-cta-bg",
  "--brand-cta-bg-hover",
  "--brand-cta-bg-active",
  "--brand-cta-text",
  "--brand-avatar-bg",
];

export const partnerAppThemeVars = (
  options?: SiteOptions | null,
): Record<string, string> | undefined => {
  if (!isPartnerBrand(options)) {
    return undefined;
  }

  const loginVars = loginPageThemeStyle(options) || {};
  const primary = resolvePartnerBrandPrimary(options);
  const accent = loginVars["--login-accent"] || "#f5f5f5";
  const primaryRgb = loginVars["--login-primary-rgb"] || "0, 0, 0";
  const accentRgb = loginVars["--login-accent-rgb"] || "245, 245, 245";

  return {
    ...loginVars,
    "--partner-primary": primary,
    "--partner-accent": accent,
    "--partner-primary-rgb": primaryRgb,
    "--partner-accent-rgb": accentRgb,
    "--valut-gold-accent": primary,
    "--valut-gold-gradient": primary,
    "--valut-gold-gradient-tint": `rgba(${primaryRgb}, 0.08)`,
    "--valut-input-border": `rgba(${primaryRgb}, 0.2)`,
    "--valut-input-border-hover": `rgba(${primaryRgb}, 0.35)`,
    "--valut-input-border-focus": primary,
    "--valut-input-focus-ring": `rgba(${primaryRgb}, 0.12)`,
    "--brand-accent": primary,
    "--brand-accent-light": primary,
    "--brand-accent-muted": primary,
    "--brand-accent-soft": `rgba(${primaryRgb}, 0.1)`,
    "--brand-accent-soft-bg": `rgba(${primaryRgb}, 0.06)`,
    "--brand-badge-bg": `rgba(${primaryRgb}, 0.08)`,
    "--brand-badge-border": `rgba(${primaryRgb}, 0.2)`,
    "--brand-cta-bg": primary,
    "--brand-cta-bg-hover": primary,
    "--brand-cta-bg-active": primary,
    "--brand-cta-text": "#ffffff",
    "--brand-avatar-bg": primary,
  };
};

export const syncPartnerAppTheme = (options?: SiteOptions | null) => {
  const root = document.documentElement;

  PARTNER_THEME_VARS.forEach((name) => {
    root.style.removeProperty(name);
  });

  const vars = partnerAppThemeVars(options);
  if (!vars) {
    root.removeAttribute("data-partner-brand");
    return;
  }

  root.setAttribute("data-partner-brand", "true");
  Object.entries(vars).forEach(([name, value]) => {
    root.style.setProperty(name, value);
  });
};

export const BRANDING_UPDATED_EVENT = "valut:branding-updated";

export const notifyBrandingUpdated = (options?: SiteOptions | null) => {
  window.dispatchEvent(
    new CustomEvent(BRANDING_UPDATED_EVENT, { detail: options }),
  );
};
